var map = {
	"./aaa-it.webp": 58602,
	"./aaa-mtsbanraw.webp": 98050,
	"./aaaa.webp": 30719,
	"./aaaaa.webp": 30030,
	"./aaaaaa.webp": 11613,
	"./aaaaaaa.webp": 2288,
	"./aaaaaaaa-mts.webp": 11856,
	"./aaaaaaaaa-aeromodelling.webp": 37713,
	"./aaaaaaaaa-chem.webp": 98256,
	"./aaaaaaaaa-chemical.webp": 16041,
	"./aaaaaaaaa-cit.webp": 52235,
	"./aaaaaaaaaa-chemical.webp": 20096,
	"./ab-cse.webp": 88572,
	"./ac-cse.webp": 96688,
	"./ad-it.webp": 53244,
	"./ae-eie.webp": 74221,
	"./af-mechatronics.webp": 97783,
	"./alumni-neha.webp": 62566,
	"./civil&ai.webp": 9350,
	"./genai.webp": 72461
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 74858;